import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.css']
})
export class ButtonComponent implements OnInit {

    @Input() text = '';
    @Output() click = new EventEmitter();

    constructor() { }

    ngOnInit(): void {
    }

    onClick(e: any) {
        this.click.emit(e);
    }
}
